import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Button from 'flarum/common/components/Button';
import Model from 'flarum/common/Model';
import Post from 'flarum/common/models/Post';

app.initializers.add('arturm/appeals', () => {
  Post.prototype.appealStatus = Model.attribute('appealStatus');

  const STATUS_LABELS = {
    pending: 'Oczekujące odwołanie',
    approved: 'Odwołanie zatwierdzone',
    semi_approved: 'Częściowo Zaakceptowane',
    rejected: 'Odwołanie odrzucone',
  };

  extend(CommentPost.prototype, 'footerItems', function (items) {
    const post = this.attrs.post;
    const status = post.appealStatus();

    if (status) {
      items.add(
        'appealStatus',
        <div className="AppealStatus" style="margin-top: 15px; padding: 10px; background: var(--control-bg, #f8f9fa); border-radius: 5px; border-left: 4px solid var(--primary-color, #007bff);">
          <strong style="margin-right: 5px;">Status: </strong>
          <span className={`AppealBadge AppealBadge--${status}`} style="font-weight: bold; margin-right: 15px;">
            {STATUS_LABELS[status] || status}
          </span>
          
          {app.session.user && (app.session.user.isAdmin() || (app.session.user.groups() || []).some(g => g.id() === '4')) && status === 'pending' ? (
            <span className="AppealActionsButtonGroup">
              <Button
                className="Button Button--primary Button--sm"
                style="margin-right: 10px; background-color: #28a745; border-color: #28a745;"
                onclick={() => {
                  post.save({ appealStatus: 'approved' }).then(() => m.redraw());
                }}
              >
                Akceptuj 
              </Button>
              <Button
                className="Button Button--warning Button--sm"
                style="margin-right: 10px; background-color: #ff9800; border-color: #ff9800; color: white;"
                onclick={() => {
                  post.save({ appealStatus: 'semi_approved' }).then(() => m.redraw());
                }}
              >
                Semi-Akceptuj
              </Button>
              <Button
                className="Button Button--danger Button--sm"
                onclick={() => {
                  post.save({ appealStatus: 'rejected' }).then(() => m.redraw());
                }}
              >
                Odrzuć
              </Button>
            </span>
          ) : null}
        </div>,
        100
      );
    }
  });
});
